import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logolight from '../../images/logo-light.png';
import logodark from '../../images/logo-dark.png';
import ScrollspyNav from "react-scrollspy-nav";

class Topbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            iscollapse : true
        };
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        var scrollY = window.scrollY;
        if (scrollY >= 50) {
            document.getElementById("sticky1").classList.add("nav-sticky");
        }
        else {
            document.getElementById("sticky1").classList.remove("nav-sticky");
        }
    }

    render() {
        return (
            <React.Fragment>
                <nav id="sticky1" className="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark nav-wrapper">
                    <div className="container">
                        <Link className="navbar-brand logo text-uppercase" to="/">
                            <img src={logolight} className="logo-light img-fluid" alt="" />
                            <img src={logodark} className="logo-dark img-fluid" alt="" />

                        </Link>
                        <button onClick={() => this.setState({ iscollapse : !this.state.iscollapse })} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                            <i className="mdi mdi-menu"></i>
                        </button>
                        <div className={ this.state.iscollapse ? "collapse navbar-collapse" : "collapse navbar-collapse show" } id="navbarCollapse">
                            <ScrollspyNav
                                scrollTargetIds={["home", "services", "clients", "pricing", "contact"]}
                                activeNavClass="st-active"
                                scrollDuration="1000"
                                headerBackground="true">

                                <ul className="navbar-nav ml-auto navbar-center" id="mySidenav">
                                    <li className="nav-item pt-1">
                                        <a href="#home" className="nav-link st-active">Home</a>
                                    </li>
                                    <li className="nav-item pt-1">
                                        <a href="#services" className="nav-link">services</a>
                                    </li>
                                    <li className="nav-item pt-1">
                                        <a href="#clients" className="nav-link">Clients</a>
                                    </li>
                                    <li className="nav-item pt-1">
                                        <a href="#pricing" className="nav-link">Pricing</a>
                                    </li>
                                    <li className="nav-item pt-1">
                                        <a href="#contact" className="nav-link">Contact</a>
                                    </li>
                                    <div className="navbar-button">
                                        <a href="#!" className="btn btn-sm btn-custom btn-round">Sign Up</a>
                                    </div>
                                </ul>

                            </ScrollspyNav>
                        </div>


                    </div>
                </nav>

            </React.Fragment>
        );
    }
}

export default Topbar;







